import { jsxs, Fragment, jsx } from 'react/jsx-runtime';

/** ![heading6Icon](data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgZmlsbD0ibm9uZSIgc3Ryb2tlPSIjMDAwIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiIHN0cm9rZS13aWR0aD0iMiI+PHJlY3QgZmlsbD0iI2ZmZiIgc3Ryb2tlPSIjZmZmIiB3aWR0aD0iMjQiIGhlaWdodD0iMjQiLz48cGF0aCBkPSJNNCAxMmg4TTQgMThWNk0xMiAxOFY2Ii8+PGNpcmNsZSBjeD0iMTkiIGN5PSIxNiIgcj0iMiIvPjxwYXRoIGQ9Ik0yMCAxMGMtMiAyLTMgMy41LTMgNiIvPjwvc3ZnPg==) */
const heading6Icon = /*#__PURE__*/jsxs(Fragment, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M4 12h8M4 18V6M12 18V6"
  }), /*#__PURE__*/jsx("circle", {
    cx: 19,
    cy: 16,
    r: 2
  }), /*#__PURE__*/jsx("path", {
    d: "M20 10c-2 2-3 3.5-3 6"
  })]
});

export { heading6Icon };
